import React from "react";
import styled from "@emotion/styled/macro";
import { Link, NavLink } from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import UMMOConfig from "config";

function ProductCard({ product }) {
  const theme = useTheme();

  return (
    <Wrapper
      style={{
        "--accent-color": product.accentColor,
        "--blackish-main": theme.palette.blackish.main,
        "--whiteish-main": theme.palette.whiteish.main,
      }}
    >
      <ProductHeading>{product.name}</ProductHeading>
      <ProductInfo>{product.description}</ProductInfo>
      <img src={product.imageSrc} alt={`${product.name} home page`}></img>
      {/* {product.name === "Hamilton.AI" ? (
        <LinkAsTab to="/hai">{UMMOConfig.text.buttonText?.toUpperCase()}</LinkAsTab>
      ) : ( */}
      <RedirectButton href={product.link}>{UMMOConfig.text.buttonText?.toUpperCase()}</RedirectButton>
      {/* )} */}
    </Wrapper>
  );
}

const RedirectButton = styled.a`
  --button-height: 2.625rem;
  width: 8.75rem;
  height: var(--button-height);
  border: 1px solid var(--blackish-main);
  font-family: "Kantar Brown";
  font-weight: 400;
  font-size: 1.25rem;
  color: var(--blackish-main);
  background-color: transparent;

  //center-button
  display: block;
  margin: 0 auto;
  margin-top: 1.938rem;

  //anchor tag overrides
  text-decoration: none;
  line-height: var(--button-height);
  text-align: center;
  cursor: pointer;
`;

const LinkAsTab = styled(NavLink)(
  ({ theme }) => `
  --button-height: 2.625rem;
  width: 8.75rem;
  height: var(--button-height);
  border: 1px solid var(--blackish-main);
  font-family: "Kantar Brown";
  font-weight: 400;
  font-size: 1.25rem;
  color: var(--blackish-main);
  background-color: transparent;

  //center-button
  display: block;
  margin: 0 auto;
  margin-top: 1.938rem;

  //anchor tag overrides
  text-decoration: none;
  line-height: var(--button-height);
  text-align: center;
  cursor: pointer;
`
);

const Wrapper = styled.div`
  --accent-border-width: 0.4375rem;
  --border-color: #dddddd;
  --transition-time: 300ms;
  width: 28.375rem;
  height: var(--collapsed-card-height);
  background-color: var(--whiteish-main);
  color: initial;
  border: 1px solid var(--border-color);
  box-shadow: 0px 0px 6.25rem 2px rgba(0, 0, 0, 0.05);
  border-bottom: 0.25rem solid var(--border-color);
  border-left: var(--accent-border-width) solid transparent;
  transition: height var(--transition-time);
  padding: 2.25rem 2rem 2.25rem calc(2rem - var(--accent-border-width));
  z-index: 2;
  img {
    height: 0;
    width: 100%;
    transition: height var(--transition-time);
  }

  &:hover {
    height: var(--expanded-card-height);
    border-left-color: var(--accent-color);
    img {
      height: 11.813rem;
    }
    ${RedirectButton} {
      background-color: black;
      color: var(--whiteish-main);
    }
  }
`;

const ProductHeading = styled.h1`
  font-weight: 400;
  font-size: 2.25rem;
`;

const ProductInfo = styled.p`
  font-weight: 300;
  font-size: 1.25rem;
  margin-bottom: 1.563rem;
`;

export default ProductCard;
